import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Link,
  Stack,
  Button,
  Card,
} from '@nextiva/next-ui-components';
import { WebsiteStatusDialog } from './WebsiteStatusDialog/WebsiteStatusDialog';
import { RequestWebsiteForm } from './RequestWebsiteForm/RequestWebsiteForm';

const dataTestId = 'PlatformAdminUI-Messaging-RequestWebsite';
export const RequestWebsiteCard = () => {
  const [openViewStatus, setOpenViewStatus] = useState(false);
  const [openRequestWebsite, setOpenRequestWebsite] = useState(false);

  return (
    <Card
      variant="outlined"
      sx={{ width: '320px', boxShadow: '0px 0px 8px 0px #22264829' }}
      data-testid={dataTestId}
    >
      <Stack spacing={3} padding="16px 24px">
        <Typography variant="h6" color="#0B1029">
          Boost your registration approval chances with your website
        </Typography>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          xs={12}
        >
          <Grid item xs={12} marginBottom={2}>
            <Typography
              variant="caption"
              color="#0B1029"
              fontWeight="800"
              component="div"
            >
              Yes, I have a business website!
            </Typography>

            <Typography variant="caption" color="#616576" component="div">
              Having a TCR compliant website increases chances of getting
              business messaging registration approved.{' '}
              <Link
                data-testid="business-website-learn-more-link"
                href="https://www.nextiva.com/support/articles/sms-faqs.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Typography variant="caption">Learn more</Typography>
              </Link>
              .
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="caption"
              color="#0B1029"
              fontWeight="800"
              component="div"
            >
              No, I don’t have it yet...
            </Typography>

            <Typography variant="caption" color="#616576" component="div">
              We can help you build a custom, compliant website for your
              business.{' '}
              <Link
                data-testid="business-website-learn-more-link"
                href="https://www.nextiva.cx/pricing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Typography variant="caption">Learn more</Typography>
              </Link>{' '}
              about our services.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          xs={12}
        >
          <Grid item xs={12} marginBottom={2}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              data-testid={`${dataTestId}-GetBusinessWebsiteButton`}
              onClick={() => setOpenRequestWebsite(true)}
            >
              Get your business website
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" color="#616576">
              Already requested?
            </Typography>
            <Button
              variant="text"
              color="secondary"
              size="small"
              onClick={() => setOpenViewStatus(true)}
              data-testid={`${dataTestId}-ViewStatusButton`}
            >
              View status
            </Button>
          </Grid>
        </Grid>
      </Stack>
      <RequestWebsiteForm
        open={openRequestWebsite}
        handleClose={() => setOpenRequestWebsite(false)}
      />
      <WebsiteStatusDialog
        handleDone={() => setOpenViewStatus(false)}
        handleOpenRequestWebsite={() => {
          setOpenRequestWebsite(true);
          setOpenViewStatus(false);
        }}
        open={openViewStatus}
      />
    </Card>
  );
};
